<template>
    <div class="main-container">
        <el-form :inline="true" :model="searchForm" size="small" ref="searchForm" @keyup.enter.native="handleSearch"
            label-width="90px">
            <el-form-item label="酒店名称" prop="name">
                <el-input v-model="searchForm.name" placeholder="酒店名称" style="width: 230px"></el-input>
            </el-form-item>
            <el-form-item label="省" prop="province">
                <el-input v-model="searchForm.province" placeholder="请输入省" style="width: 230px"></el-input>
            </el-form-item>
            <el-form-item label="市" prop="city">
                <el-input v-model="searchForm.city" placeholder="请输入市" style="width: 230px"></el-input>
            </el-form-item>
            <el-form-item label="入驻时间" prop="selectTime">
                <el-date-picker v-model="selectTime" type="daterange" value-format="yyyy-MM-dd" format="yyyy-MM-dd"
                    key="picker1" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                    @change="handleChangeDate"></el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="handleSearch" size="small">查询</el-button>
                <el-button @click="handleReset" size="small">重置</el-button>
            </el-form-item>
        </el-form>

        <div style="padding-bottom: 10px">
            <el-button icon="el-icon-plus" type="primary" size="small" v-if="pagePermission.includes('add')"
                @click="handleAddHotel">添加</el-button>
        </div>

        <el-table border size="small" style="width:100%;margin-top:10px;" :data="tableData" v-loading="isLoading"
            element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.8)">
            <el-table-column type="index" label="#" align="center"></el-table-column>
            <el-table-column prop="createTime" label="入驻时间" align="center" width="200"></el-table-column>
            <el-table-column prop="id" label="酒店ID" width="150"></el-table-column>
            <el-table-column prop="name" label="酒店名称" width="300"></el-table-column>
            <el-table-column prop="province" label="省" width="150"></el-table-column>
            <el-table-column prop="city" label="市" width="150"></el-table-column>
            <el-table-column prop="address" label="详细地址" width="200"></el-table-column>
            <el-table-column prop="landline" label="前台电话" width="120"></el-table-column>
            <el-table-column prop="contact" label="酒店联系人" width="200" show-overflow-tooltip></el-table-column>
            <el-table-column prop="contactPhone" label="联系人电话" width="120"></el-table-column>
            <el-table-column label="操作" fixed="right" align="center" width="150">
                <template slot-scope="{ row }">
                    <el-button size="mini" type="text" v-if="pagePermission.includes('edit')"
                        @click="handleEditHotel(row)">编辑</el-button>
                    <el-button size="mini" type="text" style="color:red" v-if="pagePermission.includes('delete')"
                        @click="handleDeleteHotel(row)">删除</el-button>
                    <el-dropdown trigger="click">
                        <span style="padding: 0 10px;cursor: pointer;margin-left: 10px;">
                            <i class="el-icon-more"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item v-if="pagePermission.includes('roomTypeConfig')">
                                <div @click="handleConfigRoomType(row)">房型配置</div>
                            </el-dropdown-item>
                            <el-dropdown-item v-if="pagePermission.includes('roomConfig')">
                                <div @click="handleConfigRoom(row)">房间配置</div>
                            </el-dropdown-item>
                            <el-dropdown-item v-if="pagePermission.includes('roomCode')">
                                <div @click="handleShareCode(row)">分享二维码</div>
                            </el-dropdown-item>
                            <el-dropdown-item v-if="pagePermission.includes('companyConfig')">
                                <div @click="handleCompanyConfig(row)">企业设置</div>
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination @size-change="handleChangeSize" @current-change="handleChangePage"
            style="text-align:right;margin-top:10px;" :current-page="searchForm.pageNumber" :page-sizes="[10, 20, 50]"
            :page-size="searchForm.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>

        <!-- 添加/编辑 -->
        <el-drawer :title="!!modelForm.id ? '编辑酒店' : '添加酒店'" :visible.sync="isShow" size="950px">
            <el-form ref="modelForm" :model="modelForm" inline label-width="110px" class="model_container"
                style="margin:0 20px" size="small" :rules="modelFormRules">
                <el-divider content-position="left">基础信息</el-divider>
                <el-form-item label="酒店名称" prop="name">
                    <el-input type="text" v-model="modelForm.name" :disabled="!!modelForm.id"
                        style="width: 250px"></el-input>
                </el-form-item>
                <el-form-item label="关联账户" prop="username">
                    <el-input type="text" v-model="modelForm.username" :disabled="!!modelForm.id"
                        style="width: 250px"></el-input>
                </el-form-item>
                <el-form-item prop="latitude" label="定位">
                    <el-input :disabled="!!modelForm.id" readonly placeholder="请选择地图"
                        :value="modelForm.latitude ? (modelForm.latitude + ',' + modelForm.longitude) : ''"
                        style="width: 250px">
                        <el-button type="primary" slot="append" icon="el-icon-position" @click="handleClickMap"></el-button>
                    </el-input>
                </el-form-item>
                <el-form-item label="详细地址" prop="address">
                    <el-input type="text" v-model="modelForm.address" :disabled="!!modelForm.id"
                        style="width: 250px"></el-input>
                </el-form-item>
                <el-form-item label="前台电话" prop="landline">
                    <el-input type="text" v-model="modelForm.landline" style="width: 250px"></el-input>
                </el-form-item>
                <el-form-item prop="contact" label="酒店联系人">
                    <el-input v-model="modelForm.contact" placeholder="请输入酒店联系人" :disabled="!!modelForm.id"
                        style="width: 250px"></el-input>
                </el-form-item>

                <el-form-item prop="contactPhone" label="联系人电话">
                    <el-input v-model="modelForm.contactPhone" :disabled="!!modelForm.id" placeholder="请输入联系人电话"
                        style="width: 250px"></el-input>
                </el-form-item>
                <div class="line"></div>

                <el-form-item prop="cover" label="酒店封面">
                    <el-upload class="image-uploader" action="/room/upload/img" :headers="headers" name="mulFile"
                        :data="{ key: 'head' }" :show-file-list="false"
                        :on-success="$event => handleAvatarSuccess($event, 'cover')" :before-upload="beforeAvatarUpload">
                        <img v-if="modelForm.cover" :src="modelForm.cover" class="avatar">
                        <div v-else class="image-uploader-icon">
                            <i class="el-icon-plus"></i>
                            <span>上传图片</span>
                        </div>
                        <div slot="tip" class="el-upload__tip"
                            style="width: 250px;line-height: 20px;font-size: 11px;color: #999999;">支持jpg .jpeg .bmp
                            .png格式，大小不超过2M，最多上传1张，建议尺寸：750px * 375px</div>
                    </el-upload>
                </el-form-item>
                <el-form-item prop="wxQrCodeUrl" label="客服微信">
                    <el-upload class="image-uploader" action="/room/upload/img" :headers="headers" name="mulFile"
                        :data="{ key: 'head' }" :show-file-list="false"
                        :on-success="$event => handleAvatarSuccess($event, 'wxQrCodeUrl')"
                        :before-upload="beforeAvatarUpload">
                        <img v-if="modelForm.wxQrCodeUrl" :src="modelForm.wxQrCodeUrl" class="avatar">
                        <div v-else class="image-uploader-icon">
                            <i class="el-icon-plus"></i>
                            <span>上传图片</span>
                        </div>
                        <div slot="tip" class="el-upload__tip"
                            style="width: 250px;line-height: 20px;font-size: 11px;color: #999999;">支持jpg .jpeg .bmp
                            .png格式，大小不超过2M，最多上传1张</div>
                    </el-upload>
                </el-form-item>
                <el-form-item prop="detailDiagramUrl" label="详情图">
                    <div class="detail_container">
                        <div class="detail_item" v-for="(item, key) in modelForm.detailDiagramUrl" :key="key">
                            <img :src="item" style="width: 150px;" />
                            <div class="image_button">
                                <i class="el-icon-zoom-in" @click="handleShowImage(item)"></i>
                                <i class="el-icon-delete" @click="handleDeleteImage(key)"></i>
                            </div>
                        </div>
                        <el-upload v-if="modelForm.detailDiagramUrl.length < 5" class="image-uploader"
                            action="/room/upload/img" :headers="headers" name="mulFile" :data="{ key: 'head' }"
                            :show-file-list="false" :on-success="$event => handleAvatarSuccess($event, 'detailDiagramUrl')"
                            :before-upload="beforeAvatarUpload">
                            <div class="image-uploader-icon">
                                <i class="el-icon-plus"></i>
                                <span>上传图片</span>
                            </div>
                            <div slot="tip" class="el-upload__tip"
                                style="width: 250px;line-height: 20px;font-size: 11px;color: #999999;">支持jpg .jpeg .bmp
                                .png格式，大小不超过2M，最多上传5张，建议尺寸：750px * 375px</div>
                        </el-upload>
                    </div>

                </el-form-item>
                <!-- <div class="line"></div> -->
                <!-- <el-form-item prop="status" label="状态">
                    <el-switch v-model="modelForm.status" :active-value="1" :inactive-value="0" active-color="#13ce66" inactive-color="#ff4949">
                    </el-switch>
                </el-form-item> -->
                <div v-if="!modelForm.id">
                    <el-divider content-position="left">营业资质</el-divider>
                    <el-form-item prop="businessLicenseUrl" label="营业执照">
                        <el-upload class="image-uploader" action="/room/upload/img" :headers="headers" name="mulFile"
                            :data="{ key: 'head' }" :show-file-list="false"
                            :on-success="$event => handleAvatarSuccess($event, 'businessLicenseUrl')"
                            :before-upload="beforeAvatarUpload">
                            <img v-if="modelForm.businessLicenseUrl" :src="modelForm.businessLicenseUrl" class="avatar">
                            <div v-else class="image-uploader-icon">
                                <i class="el-icon-plus"></i>
                                <span>上传图片</span>
                            </div>
                            <div slot="tip" class="el-upload__tip"
                                style="width: 250px;line-height: 20px;font-size: 11px;color: #999999;">支持jpg .jpeg .bmp
                                .png格式，大小不超过2M，最多上传1张</div>
                        </el-upload>
                    </el-form-item>
                    <el-form-item prop="hasDeadline" label="是否有期限">
                        <el-switch v-model="modelForm.hasDeadline" :active-value="1" :inactive-value="0" active-color="#13ce66" inactive-color="#ff4949">
                        </el-switch>
                    </el-form-item>
                    <el-form-item label="期限" prop="deadline" v-if="modelForm.hasDeadline == 1">
                        <el-date-picker v-model="modelForm.deadline" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date" placeholder="选择执照日期" style="width: 250px"></el-date-picker>
                    </el-form-item>
                    <div class="line"></div>
                    <el-form-item prop="identityPhysiognomyUrl" label="法人身份证正面">
                        <el-upload class="image-uploader" action="/room/upload/img" :headers="headers" name="mulFile"
                            :data="{ key: 'head' }" :show-file-list="false"
                            :on-success="$event => handleAvatarSuccess($event, 'identityPhysiognomyUrl')"
                            :before-upload="beforeAvatarUpload">
                            <img v-if="modelForm.identityPhysiognomyUrl" :src="modelForm.identityPhysiognomyUrl"
                                class="avatar">
                            <div v-else class="image-uploader-icon">
                                <i class="el-icon-plus"></i>
                                <span>上传图片</span>
                            </div>
                            <div slot="tip" class="el-upload__tip"
                                style="width: 250px;line-height: 20px;font-size: 11px;color: #999999;">支持jpg .jpeg .bmp
                                .png格式，大小不超过2M，最多上传1张</div>
                        </el-upload>
                    </el-form-item>
                    <el-form-item prop="identityNationalEmblemUrl" label="法人身份证反面">
                        <el-upload :disabled="!!modelForm.id" class="image-uploader" action="/room/upload/img"
                            :headers="headers" name="mulFile" :data="{ key: 'head' }" :show-file-list="false"
                            :on-success="$event => handleAvatarSuccess($event, 'identityNationalEmblemUrl')"
                            :before-upload="beforeAvatarUpload">
                            <img v-if="modelForm.identityNationalEmblemUrl" :src="modelForm.identityNationalEmblemUrl"
                                class="avatar">
                            <div v-else class="image-uploader-icon">
                                <i class="el-icon-plus"></i>
                                <span>上传图片</span>
                            </div>
                            <div slot="tip" class="el-upload__tip"
                                style="width: 250px;line-height: 20px;font-size: 11px;color: #999999;">支持jpg .jpeg .bmp
                                .png格式，大小不超过2M，最多上传1张</div>
                        </el-upload>
                    </el-form-item>
                </div>
                <!-- <div v-if="!modelForm.id">
                    <el-divider content-position="left">银行卡信息</el-divider>
                    <el-form-item prop="bankCardInfo.bankName" label="银行">
                        <el-input v-model="modelForm.bankCardInfo.bankName" placeholder="请输入联系人电话"
                            style="width: 250px"></el-input>
                    </el-form-item>
                    <el-form-item prop="bankCardInfo.branchInfo" label="网点信息">
                        <el-input v-model="modelForm.bankCardInfo.branchInfo" placeholder="请输入联系人电话"
                            style="width: 250px"></el-input>
                    </el-form-item>
                    <el-form-item prop="bankCardInfo.bankCardNo" label="银行卡号">
                        <el-input v-model="modelForm.bankCardInfo.bankCardNo" placeholder="请输入联系人电话"
                            style="width: 250px"></el-input>
                    </el-form-item>
                    <el-form-item prop="bankCardInfo.bankName" label="身份证号">
                        <el-input v-model="modelForm.bankCardInfo.bankName" placeholder="请输入联系人电话"
                            style="width: 250px"></el-input>
                    </el-form-item>
                    <el-form-item prop="bankCardInfo.bankPhone" label="手机号">
                        <el-input v-model="modelForm.bankCardInfo.bankPhone" placeholder="请输入联系人电话"
                            style="width: 250px"></el-input>
                    </el-form-item>
                    <el-form-item prop="bankCardInfo.bankUserName" label="真实姓名">
                        <el-input v-model="modelForm.bankCardInfo.bankUserName" placeholder="请输入联系人电话"
                            style="width: 250px"></el-input>
                    </el-form-item>
                </div> -->

            </el-form>

            <div class="footer" style="margin:0 20px;text-align:right;">
                <el-button type="text" @click="isShow = false">取消</el-button>
                <el-button type="primary" size="small" :loading="submitLoading"
                    @click="handleSubmit('modelForm')">提交</el-button>
            </div>
        </el-drawer>

        <el-dialog :visible.sync="mapVisible" title="定位" width="660px" append-to-body destroy-on-close
            :close-on-press-escape="false" :close-on-click-modal="false">

            <input type="text" id="suggestId" placeholder="请输入您的酒店详细地址" v-model="address_detail"
                class="el-input__inner el-input el-input--small el-input--suffix "
                style="width: 350px; margin-right: 20px; height: 32px; line-height: 32px">
            <div id="allmap" style="width: 620px; height: 400px;margin-top: 10px;"></div>

            <div slot="footer">
                <el-button size="small" type="primary" @click="handleConfirmMap">确定</el-button>
            </div>
        </el-dialog>

        <el-dialog :visible.sync="isView" title="图片" width="500px" append-to-body destroy-on-close
            :close-on-press-escape="false" :close-on-click-modal="false">
            <div id="capture" class="view_hb">
                <!-- <div class="title">这是海报标题</div> -->
                <div class="content">
                    <img crossorigin='anonymous' :src="rowInfo.baseUrl" alt="" style="height: 550px;max-width: 450px;">
                    <!-- 这是隐藏的内容 -->
                    <p id="name"></p>
                    <div class="flex_d">
                        <div class="mini_code">
                            <img :src="imgUrl" alt="" style="max-height: 150px;max-width: 150px;border-radius: 50%;" />
                        </div>
                        <div class="hotel_info">
                            <span style="font-size:15px">{{rowInfo.name}}</span>
                            <span style="font-size:12px">长按图片扫码,进入小程序</span>
                        </div>
                    </div>
                    <div class="address">{{rowInfo.address}}</div>
                </div>
            </div>
            <!-- <div id="result" class="result" v-if="showResultImg"></div> -->
            <div slot="footer">
                <!-- <el-button @click="drawImage">生成海报</el-button> -->
                <el-button @click="saveFile">保存海报</el-button>
                <el-button size="small" type="primary" @click="isView = false">关闭</el-button>
            </div>
        </el-dialog>
        <!-- 房型配置 -->
        <RoomTypeComponent :isRoomType="isRoomType" :hotelId="hotelId" @close="isRoomType = false"/>
        <!-- 房间列表 -->
        <RoomComponent :isRoom="isRoomConfig" :hotelId="hotelId" @close="isRoomConfig = false"/>
        <CompanyConfigComponent :isRoomType="isCompanyConfig" :hotelId="hotelId" @close="isCompanyConfig = false"/>

    </div>
</template>

<script>
import BMap from 'BMap';//引入百度地图
import { bd09togcj02, gcj02tobd09, imgToBase64 } from "../../utils/util";
import RoomTypeComponent from "./roomTypeComponent/index";
import CompanyConfigComponent from "./companyConfigComp/index";
import html2canvas from 'html2canvas';
import RoomComponent from "./roomComponent/index";

export default {
    name: "hotelManage",
    components: {
        RoomTypeComponent,
        CompanyConfigComponent,
        RoomComponent
    },
    computed: {
        pagePermission() {
            return this.$store.state.pagePermission;
        },
        headers() {
            return {
                "Authorization": localStorage.getItem('Token'),
            }
        },
    },
    data() {

        return {
            map: null,
            showResultImg: false,
            searchForm: {
                name: "",
                province: "",
                city: "",
                startDate: "",
                endDate: "",
                pageSize: 10,
                pageNumber: 1,
            },
            selectTime: null,
            isLoading: false,
            tableData: [],
            total: 0,
            isShow: false,
            modelForm: {
                name: "",
                username: "",
                province: "",
                city: "",
                latitude: "",
                longitude: "",
                address: '',
                landline: "",
                contact: "",
                contactPhone: "",
                cover: "",
                wxQrCodeUrl: "",
                detailDiagramUrl: [],
                hasDeadline: 0,
                deadline: "",
                // status: 1,
                businessLicenseUrl: "",
                identityNationalEmblemUrl: "",
                identityPhysiognomyUrl: "",
                bankCardInfo: {
                    bankCardNo: "",
                    bankIdentityNo: "",
                    bankName: "",
                    bankPhone: "",
                    bankUserName: "",
                    branchInfo: ""
                }
            },
            modelFormRules: {
                name: [{ required: true, message: "请输入酒店名称", trigger: "blur" }],
                username: [{ required: true, message: "请选择关联账户", trigger: "blur" }],
                latitude: [{ required: true, message: "请选择定位", trigger: "blur" }],
                address: [{ required: true, message: "详细地址不能为空", trigger: "blur" }],
                landline: [{ required: true, message: "前台电话只能为纯数字",pattern: /^\d{1,}$/, trigger: "blur" }],
                contact: [{ required: true, message: "请输入酒店联系人", trigger: "blur" }],
                contactPhone: [{ required: true, message: "请输入联系人电话", pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/, trigger: "blur" }],
                cover: [{ required: true, message: "请上传酒店封面", trigger: "change" }],
                wxQrCodeUrl: [{ required: true, message: "请上传客服微信", trigger: "change" }],
                businessLicenseUrl: [{ required: true, message: "请上传营业执照", trigger: "change" }],
                deadline:[{ required: true, message: "请选择营业执照期限", trigger: "change" }],
            },
            mapVisible: false,
            address_detail: "",
            userlocationPoint: { lng: "", lat: "" },
            location: { address: "" },
            submitLoading: false,

            isView: false,
            imgUrl: "",
            isRoomType: false,
            isRoomConfig: false,
            hotelId: null,
            rowInfo: {},
            isCompanyConfig: false
        }
    },
    methods: {
        //生成
        // drawImage(){
        //     this.showResultImg = true
        //     let options = {
        //         useCORS:true, // 使用跨域
        //         ignoreElements:false,
        //         allowTaint: true,
        //         scale:6, //dpi 设置默认值，提高图片分辨率
        //     };
        //     html2canvas(document.querySelector('#capture'),options).then(canvas=>{
        //         let url = canvas.toDataURL('image/png') // 将canvas转成base64图片格式
        //         // document.querySelector('#result').innerHTML = `<img src="${url}" alt="海报"  width="100%" height="100%"/>`
        //     })
        // },
        // 保存海报
        saveFile(){
            // this.drawImage()
            let options = {
                useCORS:true, // 使用跨域
                scale:6,
                allowTaint: true,
                ignoreElements:(ele) =>{ //忽略的dom元素，保存海报就不会显示这个元素内容
                    if(ele.id === 'name'){
                            return true
                    }
                }
            }
            html2canvas(document.querySelector('#capture'),options).then(canvas=>{
                canvas.toBlob(function(blob){
                    var a = document.createElement('a')
                    var url = window.URL.createObjectURL(blob)
                    var filename = '海报.png'
                    a.href = url
                    a.download = filename
                    a.click()
                    // 当图片文件加载完成释放这个url
                    window.URL.revokeObjectURL(url)
                })
            })
        },
        handleConfigRoom(row) {
            this.hotelId = row.id;
            this.isRoomConfig = true;
        },
        handleConfigRoomType(row) {
            this.hotelId = row.id;
            this.isRoomType = true;
        },
        async handleShareCode(row) {
            const { cover, ...item } = row;
            let baseUrl = '';
            this.exportRequest(`${cover}`).then(res => {
                let reader = new FileReader();
                reader.readAsText(res.data, "utf-8")
                reader.onload = e => {
                    let data = e.target.result;
                    if (!data.includes("msg")) {
                        let blob = new Blob([res.data], { type: 'image/png' });
                        // let url = window.URL.createObjectURL(blob);

                        let reader = new FileReader();
                        reader.readAsDataURL(blob);

                        reader.onload = e => {
                            baseUrl = e.target.result;
                            this.rowInfo = {baseUrl, ...item};

                            this.isView = true
                        }
                    } else {
                        this.$message.warning(JSON.parse(data).msg);
                    }

                }
            })
            this.exportRequest(`/api/hotel/getMiniProgramCode?hotelId=${row.id}&path=/pages/index/index`)
            .then(res => {
                let reader = new FileReader();
                reader.readAsText(res.data, "utf-8")
                reader.onload = e => {
                    let data = e.target.result;
                    if (!data.includes("msg")) {
                        let blob = new Blob([res.data], { type: 'image/png' });
                        // let url = window.URL.createObjectURL(blob);

                        let reader = new FileReader();
                        reader.readAsDataURL(blob);

                        reader.onload = e => {
                            this.imgUrl = e.target.result;
                            this.isView = true
                        }
                    } else {
                        // this.$message.warning(JSON.parse(data).msg);
                    }

                }
            })
        },
        handleShowImage(item) {
            this.isView = true;
            this.imgUrl = item;
        },
        handleDeleteImage(key) {
            this.modelForm.detailDiagramUrl.splice(key, 1);
        },
        handleAvatarSuccess(res, string) {
            if (string == "detailDiagramUrl") {
                this.modelForm.detailDiagramUrl.push(res.data);
            } else {
                this.modelForm[string] = res.data;
            }
            // this.modelForm.qrCode = res.data;

        },
        beforeAvatarUpload(file) {
            const isJPG = (file.type === 'image/jpeg') || (file.type === 'image/jpe') || (file.type === 'image/png') || (file.type === 'image/bmp');
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (!isJPG) {
                this.$message.error('上传头像图片只能是 JPG/JPEG/PNG/BMP 格式!');
            }
            if (!isLt2M) {
                this.$message.error('上传头像图片大小不能超过 2MB!');
            }
            return isJPG && isLt2M;
        },

        handleSubmit(fromName) {
            this.$refs[fromName].validate(valid => {
                if (valid) {
                    this.submitLoading = true;
                    if (!this.modelForm.id) {
                        this.postRequest('/hotelRegistration/addAndAudit', this.modelForm)
                            .then(res => {
                                this.submitLoading = false;
                                let data = res.data;
                                if (data.code == 200) {
                                    this.$message.success(data.msg);
                                    this.isShow = false;
                                    this.getTableData();
                                }
                            }).catch(() => {
                                this.submitLoading = false;
                            })
                    } else {
                        this.postRequest('/api/hotel/modify', this.modelForm)
                            .then(res => {
                                this.submitLoading = false;
                                let data = res.data;
                                if (data.code == 200) {
                                    this.$message.success(data.msg);
                                    this.isShow = false;
                                    this.getTableData();
                                }
                            }).catch(() => {
                                this.submitLoading = false;
                            })
                    }
                }
            })
        },
        handleAddHotel() {
            this.modelForm = {
                name: "",
                username: "",
                province: "",
                city: "",
                latitude: "",
                longitude: "",
                address: '',
                landline: "",
                contact: "",
                contactPhone: "",
                cover: "",
                wxQrCodeUrl: "",
                detailDiagramUrl: [],
                hasDeadline: 0,
                deadline: "",
                // status: 1,
                businessLicenseUrl: "",
                identityNationalEmblemUrl: "",
                identityPhysiognomyUrl: "",
                bankCardInfo: {
                    bankCardNo: "",
                    bankIdentityNo: "",
                    bankName: "",
                    bankPhone: "",
                    bankUserName: "",
                    branchInfo: ""
                }
            };
            this.isShow = true;
        },
        handleEditHotel(item) {

            this.getRequest(`/api/hotel/get/${item.id}`)
                .then(res => {
                    let data = res.data;
                    if (data.code == 200) {
                        data.data.detailDiagramUrl = data.data.detailDiagramUrl || [];
                        this.modelForm = data.data;
                        this.isShow = true;
                    }
                })
        },

        handleDeleteHotel(item) {
            this.$confirm("确定将选择数据删除?", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                this.postRequest(`/api/hotel/delete/${item.id}`)
                    .then(res => {
                        let data = res.data;
                        if (data.code == 200) {
                            this.$message.success('删除成功');
                            this.getTableData();
                        }
                    })
            })
        },
        handleChangeDate(date) {
            if (date.length) {
                this.searchForm.startDate = date[0];
                this.searchForm.endDate = date[1];
            }
        },

        handleSearch() {
            this.searchForm.pageNumber = 1;
            this.getTableData();
        },

        handleReset() {
            this.searchForm = {
                name: "",
                province: "",
                city: "",
                startDate: "",
                endDate: "",
                pageSize: 10,
                pageNumber: 1,
            };
            this.selectTime = '',
                this.getTableData();
        },

        handleChangePage(page) {
            this.searchForm.pageNumber = page;
            this.getTableData();
        },

        handleChangeSize(size) {
            this.searchForm.pageNumber = 1;
            this.searchForm.pageSize = size;
            this.getTableData();
        },
        getTableData() {
            this.isLoading = true;
            this.getRequest("/api/hotel/page", this.searchForm)
                .then(res => {
                    this.isLoading = false;
                    let data = res.data;
                    if (data.code == 200) {
                        this.tableData = data.data.records;
                        this.total = data.data.total;
                    }
                }).catch(() => {
                    this.isLoading = false;
                })
        },

        handleClickMap() {
            // if (!!this.modelForm.id) return;
            this.mapVisible = true;
            if (!this.modelForm.id && !this.modelForm.longitude) {
                this.modelForm.longitude = "";
                this.modelForm.latitude = "";
            }

            this.userlocationPoint.lng = this.modelForm.longitude;
            this.userlocationPoint.lat = this.modelForm.latitude;

            if (this.modelForm.longitude) {
                let point = gcj02tobd09(this.modelForm.longitude, this.modelForm.latitude);
                this.userlocationPoint.lng = point[0];
                this.userlocationPoint.lat = point[1];
            }

            setTimeout(() => {
                this.mapReady();
                this.address_detail = this.modelForm.address;
            }, 600);
        },

        handleConfirmMap() {//确认地图搜索
            if (!this.userlocationPoint.lat) {
                this.$message.warning("请确定您场所的位置！");
                return false;
            }

            this.mapVisible = false;
            this.modelForm.address = this.location.address;
            this.modelForm.province = this.location.province;
            this.modelForm.city = this.location.city;
            if (this.userlocationPoint.lng) {
                let point = bd09togcj02(this.userlocationPoint.lng, this.userlocationPoint.lat);
                this.modelForm.longitude = point[0];
                this.modelForm.latitude = point[1];
            }

        },
        handleCompanyConfig(item) {
            this.hotelId = item.id;
            this.isCompanyConfig = true;
        },

        mapReady() {
            var _this = this;

            this.$nextTick(function () {
                // 创建Map实例
                var map = new BMap.Map("allmap", { enableMapClick: false });
                this.map = map;
                // map.addControl(new BMap.MapTypeControl({ mapTypes: ["BMAP_NORMAL_MAP"] }));
                map.disablePinchToZoom();
                map.disableDoubleClickZoom();
                map.disableDragging();     //禁止拖拽
                map.disableScrollWheelZoom();//禁止缩放
                var point;
                if (this.userlocationPoint.lng) {
                    point = new BMap.Point(this.userlocationPoint.lng, this.userlocationPoint.lat); // 创建点坐标，汉得公司的经纬度坐标
                } else {
                    point = new BMap.Point(113.834167, 22.758345); // 创建点坐标，深圳公司的经纬度坐标
                }
                setTimeout(() => {
                    map.centerAndZoom(point, 18);
                    map.enableScrollWheelZoom(); //启动鼠标滚轮操作
                    let marker = new BMap.Marker(point)
                    map.addOverlay(marker);
                }, 300);


                //建立一个自动完成的对象
                var ac = new BMap.Autocomplete({
                    "input": "suggestId",
                    "location": map
                });

                ac.setInputValue(_this.address_detail);
                var myValue;
                //鼠标点击下拉列表后的事件
                ac.addEventListener("onconfirm", function (e) {
                    var _value = e.item.value;
                    myValue = _value.province + _value.city + _value.district + _value.street + _value.business;
                    _this.address_detail = myValue;
                    setPlace(_value);
                });

                function setPlace(item) {
                    //清除地图上所有覆盖物
                    map.clearOverlays();
                    //智能搜索
                    var local = new BMap.LocalSearch(map, {
                        onSearchComplete: function (results) {
                            //获取第一个智能搜索的结果
                            const pointResult = results.getPoi(0);
                            _this.userlocationPoint = pointResult.point;
                            pointResult.province = pointResult.province ? pointResult.province : item.province;
                            pointResult.city = pointResult.city ? pointResult.city : item.city;
                            pointResult.district = pointResult.district ? pointResult.district : item.district;
                            _this.location = pointResult;

                            _this.location.address = _this.address_detail;
                            map.centerAndZoom(_this.userlocationPoint, 18);
                            //添加标注
                            map.addOverlay(new BMap.Marker(_this.userlocationPoint));
                        }
                    });

                    local.search(myValue);
                    //测试输出坐标（指的是输入框最后确定地点的经纬度）
                }
            })
        },

    },

    mounted() {
        this.getTableData();
    },

}
</script>

<style type="less">@import url("./index.less");</style>